import * as React from "react";
import { cn } from "@/lib/utils";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowRight01Icon } from "@hugeicons/core-free-icons";

interface ShinyButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  glow?: boolean;
  stopping?: boolean;
  small?: boolean;
}

export function ShinyButton({ children, className, glow = false, stopping = false, small = false, ...props }: ShinyButtonProps) {
  return (
    <button
      className={cn(
        "shiny-cta focus:outline-none group",
        glow && "shiny-cta-glow",
        stopping && "shiny-cta-stopping",
        small && "shiny-cta-small",
        className
      )}
      {...props}
    >
      <span className="flex items-center gap-2">
        {children}
        <HugeiconsIcon 
          icon={ArrowRight01Icon} 
          size={small ? 16 : 20} 
          className="transition-all duration-300 ease-in-out group-hover:translate-x-1" 
        />
      </span>
    </button>
  );
}
